export const colors = {
  textColor: '#ffffff',
  primaryColor: '#902923',
  modalColor: '#992B26',
  lightBackground: '#af5751',
  secondColor: '#D6D5C9',
  shadowColor: '#C8C8B6',
  greyColor: '#626558',
  darkColor: '#0A100D',
};
